export enum DateFormats {
  DEFAULT = 'DD/MM/YYYY, HH:mm',
  EUROPEAN = 'DD.MM.YYYY, HH:mm',
  EUROPEAN_DEFAULT = 'DD.MM.YYYY',
  DATE_WITHOUT_HOURS = 'DD.MM.YYYY',
  DATE_SHORT = 'DD.MM',
  DATE_YEAR_MONTH_DAY = 'YYYY-MM-DD',
}
